module.exports = __webpack_public_path__ + "static/media/รายงานสถิติการผิดนัด.ef494037.xls";